import React, { FunctionComponent, useEffect } from 'react'
import Modal from 'react-modal'

const style = require('./Modal.css')

interface Props {
  showModal: Boolean,
  onClose: () => void,
  children: React.ReactNode;
}

export const ModalComponent: FunctionComponent<Props> = ({
  showModal,
  onClose,
  children,
}) => {
  useEffect(() => (typeof(window) !== 'undefined') && Modal.setAppElement('body'), [])
  
  return (
    <Modal
      contentLabel="Modal"
      overlayClassName={style.overlay}
      isOpen={showModal}
      onRequestClose={onClose}
      className={style.base}
    >
      {children}
    </Modal>
  )
}